// extracted by mini-css-extract-plugin
export var modalFooter = "_na-0";